export const SESSION_STORAGE_KEYS = {
  PENDING_MANUAL_CONNECTION: 'pendingManualConnection',
  PENDING_DEEPLINK_SECOND_ACTION: 'pendingDeeplinkSecondAction',
  PENDING_DEEPLINK_SECOND_ACTION_PROPS: 'pendingDeeplinkSecondActionProps',
  PENDING_DEEPLINK_ORIGIN: 'pendingDeeplinkOrigin',
  // Survives Auth0 full-page redirect so web can finish existing-account linking on hash return.
  HAS_PENDING_ACCOUNT_LINK: 'hasPendingAccountLink',
}

export const getSessionItem = (key: string): string | null =>
  globalThis.sessionStorage?.getItem(key) ?? null

export const setSessionItem = (key: string, value: string): void =>
  globalThis.sessionStorage?.setItem(key, value)

export const removeSessionItem = (key: string): void => globalThis.sessionStorage?.removeItem(key)
